/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { OperationMode } from 'src/app/models/enums/operation-mode.enum';
import { SampleTransaction } from 'src/app/models/sample-transaction.model';

@Injectable()
export class MockPaymentSummaryService {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  constructor() {
    // This is intentional
  }

  public getCargoPaymentInfo(): SampleTransaction {
    const sample = new SampleTransaction(
      'USD',
      1200.5,
      'PADFW0000000029',
      '021-12345678',
      'SEA',
      OperationMode.CL,
      'Y',
      'Export',
      undefined,
      '123456',
      undefined,
      210832,
      'Y'
    );
    return sample;
  }

  public getCargoPaymentInfoSignatureRequired(): SampleTransaction {
    const result = this.getCargoPaymentInfo();
    result.signatureRequired = 'Y';
    return result;
  }

  public getCargoPaymentInfoSignatureNotRequired(): SampleTransaction {
    const result = this.getCargoPaymentInfo();
    result.signatureRequired = 'N';
    return result;
  }

  public getData(): SampleTransaction {
    const sample = new SampleTransaction(
      'USD',
      1200.5,
      'PADFW0000000029',
      '021-12345678',
      'SEA',
      OperationMode.CL,
      'Y',
      'Export',
      'AWB',
      '123456',
      'DHL',
      21711910832
    );
    return sample;
  }
}
